export const VH_LOADING = "OPS_LOADING";
export const VH_ERROR = "OPS_ERROR";
export const FETCH_VEHICLES = "FETCH_VEHICLES";
export const GET_VEHICLE_STATUS_STATISTICS="TYPES.GET_VEHICLE_STATUS_STATISTICS"
